import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { DisassociateChannelFlow } from "../schemas/schemas_0";
export { $Command };
export class DisassociateChannelFlowCommand extends $Command
    .classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [getEndpointPlugin(config, Command.getEndpointParameterInstructions())];
})
    .s("ChimeMessagingService", "DisassociateChannelFlow", {})
    .n("ChimeSDKMessagingClient", "DisassociateChannelFlowCommand")
    .sc(DisassociateChannelFlow)
    .build() {
}
